import { render, staticRenderFns } from "./NetaNewMultiAttractionComponent.vue?vue&type=template&id=f48c5be8&"
import script from "./NetaNewMultiAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewMultiAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewMultiAttractionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f48c5be8')) {
      api.createRecord('f48c5be8', component.options)
    } else {
      api.reload('f48c5be8', component.options)
    }
    module.hot.accept("./NetaNewMultiAttractionComponent.vue?vue&type=template&id=f48c5be8&", function () {
      api.rerender('f48c5be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-new/NetaNewMultiAttractionComponent.vue"
export default component.exports